import React, { Component } from 'react';
import { YMInitializer } from 'react-yandex-metrika';

import { withAppData, AppDataProps } from 'client/contexts/app-data';

class Metrika extends Component<AppDataProps> {
    public render() {
        const { appData } = this.props;

        const metrikaId = parseInt(appData.settings.metrikaCounterId as string, 10);
        const metrikaOptions = appData.metrikaOptions;

        if (!metrikaId) {
            return null;
        }

        /* tslint:disable jsx-no-array-literal-props */
        return (
            <YMInitializer
                accounts={[metrikaId]}
                options={metrikaOptions}
            />
        );
    }
}

export default withAppData(Metrika);
